import gql from 'graphql-tag';

import type { Brief } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { BRIEF_FRAGMENT } from './schema';

const QUERY = gql`
  query QueryBrief($id: ID!) {
    brief(id: $id) {
      ...Brief
    }
  }
  ${BRIEF_FRAGMENT}
`;

export const queryBrief = async (id: ID): Promise<Brief | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });

  return getSingleProp<Brief>(result.data);
};
